import { DeleteButton, EditButton, SaveButton, Toolbar, TopToolbar, useGetMany, useGetManyReference, useList, useRecordContext, useTranslate } from 'react-admin';
import { Contract } from '../types';
import { numberFormatConfiguration, locale } from '../components/numberFormatConfiguration';
import { Grid, Box, Typography, Stack, BoxProps, Chip } from '@mui/material';


export const ContractShowTitle = () => {
  const record = useRecordContext();

  const { data: supabaseInvoices } = useGetManyReference(
    'sb_invoices',
    { target: 'contract_id', id: record?.id },
    { enabled: !!record }
  );

  const { data: supabaseCreditMemos } = useGetManyReference(
    'sb_creditmemos',
    { target: 'contract_id', id: record?.id },
    { enabled: !!record }
  );

  const { data: qbInvoicesData, isLoading: isInvoicesLoading } = useGetMany(
    'invoices',
    {
      ids: supabaseInvoices
        ? supabaseInvoices.map((invoice) => invoice.accounting_reference_id)
        : [],
    },
    { enabled: supabaseInvoices && supabaseInvoices.length > 0 }
  );

  const { data: qbCreditMemosData, isLoading: isCMLoading } = useGetMany(
    'creditmemos',
    {
      ids: supabaseCreditMemos
        ? supabaseCreditMemos.map((cm) => cm.accounting_reference_id)
        : [],
    },
    { enabled: supabaseInvoices && supabaseInvoices.length > 0 }
  );

  const hasInvoice = qbInvoicesData && qbInvoicesData.length > 0 ? true : false;
  const hasCreditMemo = qbCreditMemosData && qbCreditMemosData.length > 0 ? true : false;

  if (!record) return null;

  const price = Intl.NumberFormat(locale, numberFormatConfiguration).format(
    record.total_amount / 100
  );


  const linesTotal = record?.lines?.reduce((accumulator: any, line: any) => {
    return accumulator + line.price;
  }, 0);


  if (record.legacy_lines?.length == 0) {
    return <Stack direction="row">{hasInvoice ? <Chip label="Invoiced" sx={{ backgroundColor: '#BFE1D5', color: 'black' }} /> : null}{hasCreditMemo ? <Chip label="CreditMemo" sx={{ backgroundColor: '#F9B7B5', color: 'black' }} /> : null}{record.is_preneed ? <Chip label="Pre-Need" sx={{ backgroundColor: '#efe', color: 'black' }} /> : null} Contract {record.id} for <Typography sx={{
      fontWeight: '400', fontSize: '1.5rem', lineHeight: '1.334', paddingLeft: '7px', color: 'black',
      ...(linesTotal < 0 && {
        color: 'red',
      })
    }}>{price}</Typography></Stack>;
  }
  else {

    let total = 0;

    record.legacy_lines?.lines?.map((line: any) => {
      if (line['Type'] != "0") {
        total += parseInt(line['Amount']);
      }
    });

    if(record.is_preneed && record.legacy_lines?.lines?.length > 0){
      total = parseFloat(record.legacy_lines['Total']) * 100;
    }


    return(
    <Stack direction="row">
      <Chip label="Import" sx={{ marginRight: '5px', backgroundColor: '#fef5e4' }} />
      {record.is_preneed ?
        <Chip label="Pre-Need" sx={{ backgroundColor: '#635bff', color: 'white' }} /> 
        : null}
      Contract {record.id} for ${total / 100}
    </Stack>
    );
  }

};